// AtmosphereBadge Component - Sensorische Hinweise im Glasmorphism-Stil

import React from 'react';
import type { AtmosphereType } from '../../types';
import { ATMOSPHERE_TYPES } from '../../types';

interface AtmosphereBadgeProps {
  atmospheres: AtmosphereType[];
  maxDisplay?: number;
  size?: 'sm' | 'md';
  className?: string;
}

export function AtmosphereBadge({
  atmospheres,
  maxDisplay = 2,
  size = 'sm',
  className = '',
}: AtmosphereBadgeProps) {
  if (!atmospheres || atmospheres.length === 0) return null;

  const displayAtmospheres = atmospheres.slice(0, maxDisplay);

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-2.5 py-1.5 text-sm',
  };

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {displayAtmospheres.map((atmoId) => {
        const atmoInfo = ATMOSPHERE_TYPES.find((a) => a.id === atmoId);
        if (!atmoInfo) return null;

        return (
          <span
            key={atmoId}
            className={`
              inline-flex items-center gap-1
              bg-white/80 backdrop-blur-md
              text-gray-800 font-medium
              rounded-full shadow-sm
              border border-white/50
              ${sizeClasses[size]}
            `}
          >
            <span className="text-base leading-none">{atmoInfo.emoji}</span>
            <span className="hidden sm:inline">{atmoInfo.label}</span>
          </span>
        );
      })}
    </div>
  );
}

// Kompakte Version nur mit Emojis (fuer sehr kleine Darstellungen)
export function AtmosphereEmojis({
  atmospheres,
  maxDisplay = 3,
}: {
  atmospheres: AtmosphereType[];
  maxDisplay?: number;
}) {
  if (!atmospheres || atmospheres.length === 0) return null;

  const displayAtmospheres = atmospheres.slice(0, maxDisplay);

  return (
    <span className="inline-flex items-center gap-0.5">
      {displayAtmospheres.map((atmoId) => {
        const atmoInfo = ATMOSPHERE_TYPES.find((a) => a.id === atmoId);
        return atmoInfo ? (
          <span key={atmoId} title={atmoInfo.label} className="text-sm">
            {atmoInfo.emoji}
          </span>
        ) : null;
      })}
    </span>
  );
}

export default AtmosphereBadge;
